export const EACH = 0
export const IF = 1
export const SIMPLE = 2
export const TAG = 3
export const SLOT = 4

export default {
  EACH,
  IF,
  SIMPLE,
  TAG,
  SLOT
}